module.exports = __webpack_public_path__ + "static/4i-06b4bfda4e139eaf3ab9872a6d66f42f.woff";